import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskClassicAppsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-classic-apps',
	path: '/jira/servicedesk/projects/:projectKey/settings/apps',
	exact: true,
};
